export const TAB_OPTIONS = [
  { id: "dashboard", label: "Lead Assignment" },
  { id: "status", label: "Status Overview" },
  { id: "activity", label: "Activity" },
];